/**
 * @flow
 * @relayHash 42da52f2de82947cbdf74a0635d821e0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CustomerUpdateInput = {|
  id: string,
  name: string,
  categoryId: string,
  originId: string,
|};
export type UpdateCustomerMutationVariables = {|
  data: CustomerUpdateInput
|};
export type UpdateCustomerMutationResponse = {|
  +updateCustomer: {|
    +id: string
  |}
|};
export type UpdateCustomerMutation = {|
  variables: UpdateCustomerMutationVariables,
  response: UpdateCustomerMutationResponse,
|};
*/


/*
mutation UpdateCustomerMutation(
  $data: CustomerUpdateInput!
) {
  updateCustomer(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "CustomerUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateCustomer",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "CustomerModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateCustomerMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateCustomerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateCustomerMutation",
    "id": null,
    "text": "mutation UpdateCustomerMutation(\n  $data: CustomerUpdateInput!\n) {\n  updateCustomer(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ef9a22e425172a9bb617f51c33415bb7';
module.exports = node;
